<template>
  <div :data-permit="permitKey" v-if="permitAllowed" :class="classStr || ''">
    <slot></slot>
  </div>
</template>

<script>
  import {checkShowPermit} from "../tools/utils";

  export default {
    props: {
      permitKey: String,
      classStr: String,
    },
    computed: {
      permitAllowed() {
        return checkShowPermit(this.$store.state.permissionList || [], this.permitKey)
      }
    }
  }
</script>

<style scoped>
</style>
